import { PublicLinkCapabilities } from './public-link-capabilities.model';

/** Snapshot of the current visitor: logged user (`active: false`), legacy link, or JWT link with capabilities. */
export interface PublicLinkAccess {
  active: boolean;
  jwt: boolean;
  capabilities: PublicLinkCapabilities;
}

/**
 * Whether a dashboard tab (route path: assets, tasks, tickets, events, devices, scenes, ...) is open to the visitor.
 * Legacy links answer through `legacyPublicLinkCapabilities` (no Tasks, no Events), so one switch serves both kinds.
 */
export function isDashboardTabAllowed(tab: string, access: PublicLinkAccess): boolean {
  if (!access.active) return true;
  const { capabilities } = access;
  // nav entries may carry a deeper path (`resources/maximo-links`); the tab is its first segment
  switch (tab.split('/')[0]) {
    case 'resources':
      return false;
    case 'events':
      return capabilities.canViewEvents;
    case 'tasks':
    case 'tickets':
      return capabilities.canViewTickets;
    case 'devices':
    case 'scenes':
      return capabilities.canViewDevices;
    default:
      return true;
  }
}

/** Where a public link visitor lands when a tab is not open to them. */
export function publicLinkFallbackTab(access: PublicLinkAccess): 'devices' | 'assets' {
  return isDashboardTabAllowed('devices', access) ? 'devices' : 'assets';
}
